/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meal_BreakfastInputs */

const en_meal_breakfast = /** @type {(inputs: Meal_BreakfastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breakfast`)
};

const de_meal_breakfast = /** @type {(inputs: Meal_BreakfastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frühstück`)
};

/**
* | output |
* | --- |
* | "Breakfast" |
*
* @param {Meal_BreakfastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const meal_breakfast = /** @type {((inputs?: Meal_BreakfastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meal_BreakfastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_meal_breakfast(inputs)
	return en_meal_breakfast(inputs)
});